import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-fa-qt1-text',
  templateUrl: './qt1-text.component.html',
  styleUrls: ['./qt1-text.component.css'],
})
export class QT1TextComponent implements OnInit {
  @Input() QuestionNo: number;
  @Input() Question: string;
  @Input() answer?: any;
  @Input() template?: any;
  @Output() selectedtemplate: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}
  q: string = '';
  ngOnInit() {
    if (this.Question == 'default' || this.Question == 'default1') {
      this.q = this.Question;
      console.log(this.Question, this.q);
      this.QuestionNo = 1;
      this.Question = 'Name the President of United States?';
      this.answer = [
        { answer: 'Answer 1' },
        { answer: 'Answer 2' },
        { answer: 'Answer 3' },
        { answer: 'Answer 4' },
      ];
    }
  }
  selecttemplate() {
    this.selectedtemplate.emit(this.template);
  }
}
